import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSafeNavigate } from "./useSafeNavigate";

// Compatibility HOC to provide history/location/match props
// to class components and older code after upgrading to react-router v6+.
const withRouter = (Component) => {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useSafeNavigate();
    const params = useParams();

    const history = {
      push: (to, state) => navigate(to, { state }),
      replace: (to, state) => navigate(to, { replace: true, state }),
      goBack: () => navigate(-1),
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={{ params }}
      />
    );
  }

  return ComponentWithRouterProp;
};

export default withRouter;


